import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../dynamicFormBuilder/FormField'
import { PrimaryLayout,  UOMLayout,  StatusLayout, CodesLayout,RefrencesLayout, CostPriceLayout } from '../Layout';


function PrimaryTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
        const formRefs = useRef({});
    const combinedLayouts = [
        { name: 'PrimaryLayout', layout: PrimaryLayout },
        { name: 'CostPriceLayout', layout: CostPriceLayout },
        { name: 'UOMLayout', layout: UOMLayout },
        { name: 'StatusLayout', layout: StatusLayout },
        { name: 'CodesLayout', layout: CodesLayout },
        { name: 'RefrencesLayout', layout: RefrencesLayout }

    ];
    
    const updatedLayouts = combinedLayouts.map(({ name, layout }) => {
        if (name !== 'PrimaryLayout') {
            return layout.map(group => ({
                ...group,
                label: "", 
                fields: group.fields.map(field => ({
                    ...field,
                    visible: false
                }))
            }));
        }
        return layout;
    });
    
    const finalLayout = updatedLayouts.flat();

    const handlePrimaryFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad(formRefs);

    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='2770A67E-69D5-4D7C-8AEF-9DB9CBA583CD'
                layoutName='IMLotDataEntryPrimaryForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={(name, value, e)=>props.handleFieldChange(name, value, e,formRefs)}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(PrimaryTab);
